import { ReactNode } from 'react'

import { VariantProps } from 'class-variance-authority'

import { helperTextStyles } from './HelperText.styles.js'

export type HelperTextProps = VariantProps<typeof helperTextStyles> & {
  className?: string
  children?: ReactNode
  id?: string
  role?: string
}
export const HelperText = ({
  status = 'neutral',
  highlighted = false,
  size,
  children,
  className,
  id,
  role,
}: HelperTextProps) => {
  return (
    <div
      id={id}
      role={role}
      className={helperTextStyles({
        size,
        status,
        highlighted,
        className,
      })}
    >
      {children}
    </div>
  )
}
